import React, { Component } from "react";

export const SvgIcon = ({ src, width, height }) => (
  <img src={src.includes('.svg')? `/img/svg/${src}`: `/img/${src}`} alt={src} width={width} height={height} />
);
